import { COLORS } from './constant';

export const ROUTES = [
  {
    label: 'dashboard_and_statistics',
    link: '',
  },
  // {
  //   label: 'breadcrumb_e_invoicing',
  //   link: 'e-invoicing',
  // },
];

export const VALUES = ({ t, env, values }) => {
  return [
    {
      type: 'certifications',
      values: {
        data: {
          title: t('chart_certifications'),
          items: [
            {
              numbers: values?.certifications?.certificateValid,
              title: t('chart_active'),
              type: 'certificateValid',
            },
            {
              numbers: values?.certifications?.certificateExpired,
              title: t('chart_expired'),
              type: 'certificateExpired',
            },
            {
              numbers: values?.certifications?.certificateRevoked,
              title: t('chart_in_revoked'),
              type: 'certificateRevoked',
            },
          ],
        },
        colors: COLORS.certificates,
      },
    },
    {
      type: 'reporting',
      values: {
        data: {
          title: t('chart_reporting'),
          items: [
            {
              numbers: values?.reporting?.passedInvoicesCount,
              title: t('chart_accepted'),
              type: 'passedInvoicesCount',
            },
            {
              numbers: values?.reporting?.errorInvoicesCount,
              title: t('chart_rejected'),
              type: 'errorInvoicesCount',
            },
            {
              numbers: values?.reporting?.warringInvoicesCount,
              title: t('chart_warning'),
              type: 'warringInvoicesCount',
            },
          ],
        },
        colors: COLORS.eInvoicing,
      },
    },
    {
      type: 'clearance',
      values: {
        data: {
          title: t('chart_clearance'),
          items: [
            {
              numbers: values?.clearance?.passedInvoicesCount,
              title: t('chart_accepted'),
              type: 'passedInvoicesCount',
            },
            {
              numbers: values?.clearance?.errorInvoicesCount,
              title: t('chart_rejected'),
              type: 'errorInvoicesCount',
            },
            {
              numbers: values?.clearance?.warringInvoicesCount,
              title: t('chart_warning'),
              type: 'warringInvoicesCount',
            },
          ],
        },
        colors: COLORS.eInvoicing,
      },
    },
  ];
};
